module.exports = __webpack_public_path__ + "3cec0717c910522061bbfdff17370057.jpg";